/**
 * URL helper functions for PostBoxModal
 */

/**
 * Validate if a string is a valid URL
 * @param {string} url - URL to validate
 * @returns {boolean}
 */
export const isValidUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

/**
 * Get favicon URL for a given URL
 * @param {string} url - URL to get favicon for
 * @returns {string|null}
 */
export const getFavicon = (url) => {
  try {
    const { hostname } = new URL(url);
    return `https://www.google.com/s2/favicons?domain=${hostname}`;
  } catch {
    return null;
  }
};

/**
 * Get domain from a URL
 * @param {string} url - URL to extract domain from
 * @returns {string}
 */
export const getDomain = (url) => {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url;
  }
};
